import { Client, tokenize } from '@idonatedev/idonate-sdk';
import ApiUtils from '@/api/util/ApiUtils';

const TOKENIZER_STYLING: tokenize.TokenizerStyling = {
  input: {
    height: '46px',
    padding: '10px 14px',
    fontSize: '14px',
    fontFamily: 'Montserrat, sans-serif',
    border: '1px solid #b6b8ba',
    borderRadius: '20px',
    backgroundColor: '#ffffff',
    color: '#212529',
    lineHeight: '1.5',
  },
  focus: {
    borderColor: '#80bdff',
    outline: 'none',
    boxShadow: '0 0 0 0.2rem rgba(0, 123, 255, 0.25)',
  },
  error: {
    borderColor: '#dc3545',
  },
  container: {
    display: 'flex',
    gap: '0.75rem',
    alignItems: 'flex-start',
  },
};

/**
 * Create a credit card tokenizer for the events-pages payment form.
 *
 * The GraphQL gateway object only carries { id, backendName }; the SDK
 * resolves the full gateway (environment key, base URL, server-driven
 * card-capture engine) from the organization's configuration.
 */
export const createEventsTokenizer = async (
  client: Client,
  containerId: string,
  gateway: { id: string },
): Promise<tokenize.Tokenizer> => {
  const paymentGateway = await client.getGateway(gateway.id);
  return client.createTokenizer(paymentGateway, {
    containerId,
    mode: 'credit_card',
    styling: TOKENIZER_STYLING,
    layout: 'responsive' as const,
    responsiveBreakpoint: 440,
  });
};

/**
 * Convert the events-pages purchaser object to SDK PaymentData format.
 */
export const buildPaymentData = (purchaser: any): tokenize.PaymentData => {
  return {
    firstName: ApiUtils.getValue(purchaser, 'firstName') || '',
    lastName: ApiUtils.getValue(purchaser, 'lastName') || '',
    email: ApiUtils.getValue(purchaser, 'email') || '',
    phone: ApiUtils.getValue(purchaser, 'phone') || '',
    address: {
      address1: ApiUtils.getValue(purchaser, 'address.street') || '',
      address2: ApiUtils.getValue(purchaser, 'address.street2') || '',
      city: ApiUtils.getValue(purchaser, 'address.city') || '',
      state: ApiUtils.getValue(purchaser, 'address.state') || '',
      zip: ApiUtils.getValue(purchaser, 'address.zip') || '',
      country: ApiUtils.getValue(purchaser, 'address.country') || '',
    },
  };
};
